module.exports = __webpack_public_path__ + "img/simplex.6af56dae.png";